<template>
    <div class="intro-container animated fadeInUp">
        <div class="title">
            非遗数字化与多源信息融合福建省高校工程研究中心
        </div>
        <div class="intro-text" v-html="baseConfig.intro"></div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "intro",
        computed: {
            ...mapGetters([
                'baseConfig'
            ]),
        }
    }
</script>

<style scoped lang="less">
    .intro-container {
        width: 100%;
        margin: auto;
        color: #fff;
        .title {
            font-size: 28px;
            font-weight: bold;
            width: 500px;
            margin-bottom: 30px;
        }
        .intro-text {
            font-size: 13px;
            width: 600px;
            line-height: 2;
            text-align: justify;
            p:first-child {
                text-indent: 28px;
            }
            p {
                text-indent: 28px;
            }

        }
    }
</style>